import {
  FormControl,
  FormHelperText,
  Grid,
  TextField,
} from '@material-ui/core';
import React from 'react';
import { Field } from 'react-final-form';
import styled from 'styled-components';
import { IQuestion } from '../../types';

interface IProps {
  question: IQuestion;
}

const TextQuestion = ({ question }: IProps) => {
  const required = (value: string) => (value ? undefined : 'Required');
  const mustBeEmail = (value: string) =>
    value?.match(/\S+@\S+\.\S+/) ? undefined : 'Invalid email address';

  return (
    <StyledGrid
      container
      direction="row"
      justify="flex-start"
      alignItems="center"
    >
      <Field
        name={`${question.id}`}
        initialValue=""
        validate={question.id === 'q-104' ? mustBeEmail : required}
      >
        {({ input: { name, value, onChange, ...restInput }, meta }) => {
          const showError =
            (meta.error && meta.touched) || (!value && meta.submitFailed);
          return (
            <>
              <QuestionContainer>{question.title}</QuestionContainer>
              <StyledFormControl variant="outlined" error={showError}>
                <TextField
                  aria-label="text-input"
                  id={`question-with-text-${name}`}
                  value={value}
                  onChange={onChange}
                  inputProps={{ ...restInput }}
                  placeholder={question.inputHelperText || ''}
                />
                {showError && (
                  <FormHelperText>
                    {question.id === 'q-104'
                      ? 'Invalid email adress'
                      : 'Required'}
                  </FormHelperText>
                )}
              </StyledFormControl>
            </>
          );
        }}
      </Field>
    </StyledGrid>
  );
};

const StyledGrid = styled(Grid)`
  margin-bottom: 30px;
`;

const QuestionContainer = styled('div')`
  width: 293px;
  font-family: EB Garamond;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  text-align: left;
`;

const StyledFormControl = styled(FormControl)`
  width: 220px;
  height: 56px;
  margin-left: 62px;
  @media (max-width: 450px) {
    margin-left: 0px;
    margin-top: 10px;
  }
`;

export default TextQuestion;
